import { render, staticRenderFns } from "./CreateEmbedCode.vue?vue&type=template&id=26635e04&scoped=true"
import script from "./CreateEmbedCode.vue?vue&type=script&lang=js"
export * from "./CreateEmbedCode.vue?vue&type=script&lang=js"
import style0 from "./CreateEmbedCode.vue?vue&type=style&index=0&id=26635e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26635e04",
  null
  
)

export default component.exports